/**
 * Check if a {@link LatLng} is within bounds
 * @param point - the point to check, in {@link LatLng} format
 * @param bounds - the bounds to check
 */
export function latlngInBounds(point, bounds) {
    return (point[0] >= bounds[0][0] &&
        point[0] <= bounds[1][0] &&
        point[1] >= bounds[0][1] &&
        point[1] <= bounds[1][1]);
}
/**
 * Check if a {@link Point}, {@link Feature} point or {@link Position} is within bounds
 * @param point - the point to check, in {@link Position}/{@link Point} format
 * @param bounds - the bounds to check
 */
export function pointInBounds(point, bounds) {
    if ('type' in point) {
        if (point.type === 'Point')
            point = point.coordinates;
        else
            point = point.geometry.coordinates;
    }
    return (point[1] >= bounds[0][0] &&
        point[1] <= bounds[1][0] &&
        point[0] >= bounds[0][1] &&
        point[0] <= bounds[1][1]);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5Cb3VuZHMuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsiaW5Cb3VuZHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0E7Ozs7R0FJRztBQUNILE1BQU0sVUFBVSxjQUFjLENBQUMsS0FBYSxFQUFFLE1BQW9CO0lBQ2pFLE9BQU8sQ0FDTixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN4QixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN4QixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN4QixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUN4QixDQUFBO0FBQ0YsQ0FBQztBQUVEOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsYUFBYSxDQUM1QixLQUF3QyxFQUN4QyxNQUFvQjtJQUVwQixJQUFJLE1BQU0sSUFBSSxLQUFLLEVBQUUsQ0FBQztRQUNyQixJQUFJLEtBQUssQ0FBQyxJQUFJLEtBQUssT0FBTztZQUFFLEtBQUssR0FBRyxLQUFLLENBQUMsV0FBVyxDQUFBOztZQUNoRCxLQUFLLEdBQUcsS0FBSyxDQUFDLFFBQVEsQ0FBQyxXQUFXLENBQUE7SUFDeEMsQ0FBQztJQUVELE9BQU8sQ0FDTixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN4QixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN4QixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN4QixLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUN4QixDQUFBO0FBQ0YsQ0FBQyJ9